// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1iIlI","right":"Footer_right__2EFF8","buttons":"Footer_buttons__AVSEt"};